﻿export * from './faq.component';
export * from './add-faq.component';